import React, { useEffect, useState } from "react";

import "./Details.scss";
import Nemodar from "../../assets/images/Screenshot (324).png";
import caret from "../../assets/images/Icon awesome-caret-left.png";
import numberwithCommas from "../common/numberWithCommas";
import code from "../../assets/images/code.png";
const Details = ({ details, data }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
    script.async = false;
    script.innerHTML = new window.TradingView.MediumWidget({
      symbols: [[`${details.nameChart}`]],
      chartOnly: false,
      width: "100%",
      height: "100%",
      locale: "en",
      colorTheme: "light",
      gridLineColor: "rgba(240, 243, 250, 0)",
      fontColor: "#787B86",
      isTransparent: false,
      autosize: true,
      showVolume: false,
      scalePosition: "no",
      scaleMode: "Normal",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, SegoeUI, Trebuchet MS, Roboto, Ubuntu, sans-serif",
      noTimeScale: false,
      valuesTracking: "1",
      chartType: "area",
      color: "rgba(251, 192, 45, 1)",
      lineColor: "rgba(251, 192, 45, 1)",
      topColor: "rgba(251, 192, 45, 0.3)",
      bottomColor: "rgba(255, 241, 118, 0)",
      container_id: "tradingview_40d40",
    });
    // myRef.current.appendChild(script);
  }, []);
  const [star, setStar] = useState(true);
  return (
    <div className="container1 row">
      <div className="col-12 title">
        {data.cc_meta_data == undefined && data.cc_data == undefined ? (
          ""
        ) : (
          <>
            <span style={{ borderBottom: "2px solid #4e0f8c" }}>
              قیمت لحظه ای{" "}
            </span>
            <span>{data.cc_meta_data.farsi_name}</span>
          </>
        )}
        <br />
        <br />
      </div>

      <div className="row">
        <div class="tradingview-widget-container col-12 col-md-12 col-xl-7 nemodar">
          <div id="tradingview_40d40"></div>
          <div class="tradingview-widget-copyright">
            <a
              href="https://www.tradingview.com/symbols/MSFT/"
              rel="noopener"
              target="_blank"
            >
              <span class="blue-text">MSFT Stock Price Today</span>
            </a>{" "}
            by TradingView
          </div>
        </div>
        <div
          className="d-none d-sm-block col-md-12 col-xl-5"
          style={{ padding: "0px" }}
          dir="ltr"
        >
          <div className="row mainleft">
            <div
              className="container-left col-sm-1 col-12 col-md-1"
              style={{ padding: "0px" }}
            >
              <div className="icon">
                {star ? (
                  <div
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="افزودن به مورد علاقه ها"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      id="star"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => setStar(!star)}
                    >
                      <path
                        id="Icon_feather-star"
                        data-name="Icon feather-star"
                        d="M13,3l3.09,6.583L23,10.645l-5,5.121L19.18,23,13,19.583,6.82,23,8,15.766,3,10.645,9.91,9.583Z"
                        transform="translate(-2 -2)"
                        fill="none"
                        stroke="#4e0f8c"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      />
                    </svg>
                  </div>
                ) : (
                  <div
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="افزودن به مورد علاقه ها"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      role="img"
                      width="22"
                      height="22"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 36 36"
                      id="star"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => setStar(!star)}
                    >
                      <g transform="translate(36 0) scale(-1 1)">
                        <path
                          fill="#4e0f8c"
                          d="M34 16.78a2.22 2.22 0 0 0-1.29-4l-9-.34a.23.23 0 0 1-.2-.15l-3.11-8.4a2.22 2.22 0 0 0-4.17 0l-3.1 8.43a.23.23 0 0 1-.2.15l-9 .34a2.22 2.22 0 0 0-1.29 4l7.06 5.55a.23.23 0 0 1 .08.24l-2.43 8.61a2.22 2.22 0 0 0 3.38 2.45l7.46-5a.22.22 0 0 1 .25 0l7.46 5a2.2 2.2 0 0 0 2.55 0a2.2 2.2 0 0 0 .83-2.4l-2.45-8.64a.22.22 0 0 1 .08-.24Z"
                          class="clr-i-solid clr-i-solid-path-1"
                        />
                        <path fill="none" d="M0 0h36v36H0z" />
                      </g>
                    </svg>
                  </div>
                )}
                <div
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="اشتراک گذاری"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.7"
                    height="20"
                    viewBox="0 0 14.7 20"
                    style={{ cursor: "pointer" }}
                  >
                    <path
                      id="Icon_material-share"
                      data-name="Icon material-share"
                      d="M16.75,17.137a2.16,2.16,0,0,0-1.6.773L9.327,13.743a3.4,3.4,0,0,0,0-1.406l5.758-4.127a2.22,2.22,0,0,0,1.666.813A2.771,2.771,0,0,0,19.2,6.012,2.771,2.771,0,0,0,16.75,3,2.771,2.771,0,0,0,14.3,6.012a4,4,0,0,0,.074.7L8.616,10.841a2.22,2.22,0,0,0-1.666-.813A2.771,2.771,0,0,0,4.5,13.04a2.771,2.771,0,0,0,2.45,3.012,2.22,2.22,0,0,0,1.666-.813l5.815,4.177a3.452,3.452,0,0,0-.065.653A2.7,2.7,0,0,0,16.75,23a2.7,2.7,0,0,0,2.385-2.932,2.7,2.7,0,0,0-2.385-2.932Z"
                      transform="translate(-4.5 -3)"
                      fill="#4e0f8c"
                    />
                  </svg>
                </div>
              </div>
              <svg
                id="Line_86"
                xmlns="http://www.w3.org/2000/svg"
                width="1"
                height="408"
                viewBox="0 0 1 408"
              >
                <line
                  data-name="Line 86"
                  y2="408"
                  transform="translate(0.5)"
                  fill="none"
                  stroke="#4e0f8c"
                  strokeWidth="1"
                />
              </svg>
            </div>
            <div
              className="col-12 col-sm-10 col-md-10"
              style={{ padding: "0px" }}
            >
              <div className="row" style={{ justifyContent: "space-between" }}>
                <div
                  className="col-12 col-sm-6 col-md-6"
                  style={{ padding: "0px" }}
                >
                  <div className="row items">
                    <div className="col-2 col-xl-3">
                      {data.cc_meta_data == undefined &&
                      data.cc_data == undefined ? (
                        ""
                      ) : (
                        <>
                          <img
                            src={data.cc_meta_data.logo}
                            alt="icon"
                            id="icon"
                          />
                        </>
                      )}
                    </div>
                    <div className="col-9" style={{ fontWeight: "bold" }}>
                      {" "}
                      {data.cc_meta_data == undefined &&
                      data.cc_data == undefined ? (
                        ""
                      ) : (
                        <>{`${data.cc_meta_data.slug}(${data.cc_meta_data.symbol})`}</>
                      )}
                    </div>
                  </div>
                  <div className="row items">
                    <div className="col-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                      >
                        <image
                          id="_3629632"
                          data-name="3629632"
                          width="34"
                          height="34"
                          xlinkHref="data:image/png;base64,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"
                        />
                      </svg>
                    </div>
                    <div className="col-10">
                      RANK{" "}
                      <span style={{ color: "#ECA72C" }}>
                        #
                        {data.cc_meta_data == undefined &&
                        data.cc_data == undefined ? (
                          ""
                        ) : (
                          <>{`${data.cc_data.cmc_rank}`}</>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="row items">
                    <div className="col-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="29.5"
                        height="28"
                        viewBox="0 0 29.5 28"
                      >
                        <g
                          id="Icon_ionic-ios-link"
                          data-name="Icon ionic-ios-link"
                          transform="translate(-3.375 -3.375)"
                        >
                          <path
                            id="Path_258"
                            data-name="Path 258"
                            d="M19.688,23.984l-.084.007a1.163,1.163,0,0,0-.675.316l-4.542,4.542a5.121,5.121,0,0,1-7.242-7.242l4.823-4.823a5.09,5.09,0,0,1,.8-.654,5.168,5.168,0,0,1,1.041-.527,4.923,4.923,0,0,1,1.055-.26,4.986,4.986,0,0,1,.717-.049c.1,0,.2.007.323.014A5.106,5.106,0,0,1,19.2,16.784a5.042,5.042,0,0,1,1.2,1.92,1.107,1.107,0,0,0,1.357.71c.007,0,.014-.007.021-.007s.014,0,.014-.007a1.1,1.1,0,0,0,.738-1.343,6.372,6.372,0,0,0-1.73-2.883,7.4,7.4,0,0,0-4.05-2.06c-.134-.021-.267-.042-.4-.056a7.256,7.256,0,0,0-.78-.042c-.183,0-.366.007-.541.021a7.091,7.091,0,0,0-1.139.176c-.077.014-.148.035-.225.056a7.314,7.314,0,0,0-1.371.513,7.223,7.223,0,0,0-1.948,1.4L5.52,20a7.417,7.417,0,0,0-2.145,5.238,7.393,7.393,0,0,0,12.614,5.224l4.591-4.591A1.113,1.113,0,0,0,19.688,23.984Z"
                            transform="translate(0 -1.25)"
                            fill="#0b0b0c"
                          />
                          <path
                            id="Path_259"
                            data-name="Path 259"
                            d="M30.466,5.534a7.41,7.41,0,0,0-10.455,0l-4.479,4.479a1.13,1.13,0,0,0,.71,1.927,1.142,1.142,0,0,0,.893-.323l4.486-4.472a5.121,5.121,0,0,1,7.242,7.242L24.04,19.209a5.09,5.09,0,0,1-.8.654,5.168,5.168,0,0,1-1.041.527,4.923,4.923,0,0,1-1.055.26,4.986,4.986,0,0,1-.717.049c-.1,0-.2-.007-.323-.014a5.053,5.053,0,0,1-4.444-3.27,1.123,1.123,0,0,0-1.343-.689,1.136,1.136,0,0,0-.795,1.441,6.423,6.423,0,0,0,1.666,2.637h0l.014.014a7.4,7.4,0,0,0,4.451,2.116,7.256,7.256,0,0,0,.78.042q.274,0,.548-.021a8.039,8.039,0,0,0,1.357-.225,7.314,7.314,0,0,0,1.371-.513,7.223,7.223,0,0,0,1.948-1.4L30.48,16a7.4,7.4,0,0,0-.014-10.462Z"
                            transform="translate(0.236)"
                            fill="#0b0b0c"
                          />
                        </g>
                      </svg>
                    </div>
                    {data.cc_meta_data == undefined &&
                    data.cc_data == undefined ? (
                      ""
                    ) : (
                      <>
                        <a
                          className="col-10"
                          href={data.cc_meta_data.urls.website[0]}
                        >
                          {data.cc_meta_data.urls.website[0]}
                        </a>
                      </>
                    )}
                  </div>
                  <div
                    className="row items"
                    style={{ flexDirection: "row", flexWrap: "nowrap" }}
                  >
                    <span className="col-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18.601"
                        height="22.404"
                        viewBox="0 0 18.601 22.404"
                      >
                        <path
                          id="Icon_ionic-ios-search"
                          data-name="Icon ionic-ios-search"
                          d="M4.718,25.275l5.173-6.288a10.1,10.1,0,0,1-1.623-5.57c0-4.929,3.318-8.924,7.416-8.924s7.416,4,7.416,8.93-3.318,8.924-7.416,8.924a6.667,6.667,0,0,1-4.674-1.995L5.871,26.6a.735.735,0,0,1-.576.3.72.72,0,0,1-.547-.262A1.109,1.109,0,0,1,4.718,25.275Zm10.966-4.847A5.339,5.339,0,0,0,19.8,18.375a7.742,7.742,0,0,0,1.705-4.952A7.719,7.719,0,0,0,19.8,8.471a5.339,5.339,0,0,0-4.117-2.053,5.339,5.339,0,0,0-4.117,2.053,7.742,7.742,0,0,0-1.705,4.952,7.719,7.719,0,0,0,1.705,4.952A5.339,5.339,0,0,0,15.685,20.428Z"
                          transform="translate(-4.5 -4.493)"
                          fill="#0b0b0c"
                        />
                      </svg>
                    </span>
                    <span>
                      {details.search.map((value, index) => {
                        return (
                          <>
                            {" "}
                            <a
                              className=""
                              href="#"
                              style={{ padding: "0px" }}
                              key={index}
                            >
                              {value.value}
                            </a>
                            {index + 1 === details.search.length ? (
                              ""
                            ) : (
                              <span style={{ marginLeft: "5px" }}>|</span>
                            )}
                          </>
                        );
                      })}
                    </span>
                  </div>
                  <div className="row items">
                    <div className="col-2 col-md-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.65"
                        height="22.93"
                        viewBox="0 0 16.65 22.93"
                      >
                        <path
                          id="Icon_material-share"
                          data-name="Icon material-share"
                          d="M18.375,19.207a2.435,2.435,0,0,0-1.813.886l-6.6-4.777a4.644,4.644,0,0,0,.083-.806,4.644,4.644,0,0,0-.083-.806l6.521-4.731a2.5,2.5,0,0,0,1.887.932c1.536,0,2.775-1.542,2.775-3.453S19.911,3,18.375,3,15.6,4.542,15.6,6.453a4.644,4.644,0,0,0,.083.806L9.162,11.99a2.5,2.5,0,0,0-1.887-.932C5.74,11.058,4.5,12.6,4.5,14.511s1.24,3.453,2.775,3.453a2.5,2.5,0,0,0,1.887-.932l6.586,4.789a4,4,0,0,0-.074.748c0,1.853,1.212,3.361,2.7,3.361s2.7-1.508,2.7-3.361-1.212-3.361-2.7-3.361Z"
                          transform="translate(-4.5 -3)"
                          fill="#0b0b0c"
                        />
                      </svg>
                    </div>
                    <div className="col-10 col-sm-4 col-md-10">
                      {data == undefined ? (
                        ""
                      ) : (
                        
                        <a href="#reddit" class="text-decoration-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-reddit"
                            style={{ marginRight: "10px", color: "#4B53F2" }}
                            viewBox="0 0 16 16"
                          >
                            <path d="M6.167 8a.831.831 0 0 0-.83.83c0 .459.372.84.83.831a.831.831 0 0 0 0-1.661zm1.843 3.647c.315 0 1.403-.038 1.976-.611a.232.232 0 0 0 0-.306.213.213 0 0 0-.306 0c-.353.363-1.126.487-1.67.487-.545 0-1.308-.124-1.671-.487a.213.213 0 0 0-.306 0 .213.213 0 0 0 0 .306c.564.563 1.652.61 1.977.61zm.992-2.807c0 .458.373.83.831.83.458 0 .83-.381.83-.83a.831.831 0 0 0-1.66 0z" />
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.828-1.165c-.315 0-.602.124-.812.325-.801-.573-1.9-.945-3.121-.993l.534-2.501 1.738.372a.83.83 0 1 0 .83-.869.83.83 0 0 0-.744.468l-1.938-.41a.203.203 0 0 0-.153.028.186.186 0 0 0-.086.134l-.592 2.788c-1.24.038-2.358.41-3.17.992-.21-.2-.496-.324-.81-.324a1.163 1.163 0 0 0-.478 2.224c-.02.115-.029.23-.029.353 0 1.795 2.091 3.256 4.669 3.256 2.577 0 4.668-1.451 4.668-3.256 0-.114-.01-.238-.029-.353.401-.181.688-.592.688-1.069 0-.65-.525-1.165-1.165-1.165z" />
                          </svg>
                        </a>
                      )}

                      <a href="#twitter">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          style={{ marginRight: "10px" }}
                          id="Icon_metro-twitter"
                        >
                          <circle
                            id="Ellipse_175"
                            data-name="Ellipse 175"
                            cx="15"
                            cy="15"
                            r="15"
                            fill="#4b53f2"
                          />
                          <path
                            id="Icon_metro-twitter"
                            data-name="Icon metro-twitter"
                            d="M17.571,6.593a5.285,5.285,0,0,1-1.767.6,3.763,3.763,0,0,0,1.353-2.1,5.52,5.52,0,0,1-1.954.919,2.842,2.842,0,0,0-2.246-1.2c-1.7,0-3.077,1.7-3.077,3.787a4.642,4.642,0,0,0,.08.863A8.331,8.331,0,0,1,3.615,5.51a4.452,4.452,0,0,0-.417,1.9,4.075,4.075,0,0,0,1.369,3.152,2.644,2.644,0,0,1-1.394-.474c0,.016,0,.032,0,.048a3.679,3.679,0,0,0,2.469,3.713,2.523,2.523,0,0,1-1.39.065,3.239,3.239,0,0,0,2.875,2.63A5.49,5.49,0,0,1,3.3,18.169a5.088,5.088,0,0,1-.734-.053,7.578,7.578,0,0,0,4.717,1.7c5.66,0,8.756-5.77,8.756-10.774q0-.246-.009-.49a7.236,7.236,0,0,0,1.536-1.96Z"
                            transform="translate(5.005 4.112)"
                            fill="#fff"
                          />
                        </svg>
                      </a>

                      <a href="#facebook">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30.33"
                          viewBox="0 0 30 30.33"
                          id="Icon_awesome-facebook"
                        >
                          <path
                            id="Icon_awesome-facebook"
                            data-name="Icon awesome-facebook"
                            d="M30.563,15.82a15.128,15.128,0,0,0-15-15.257,15.128,15.128,0,0,0-15,15.257A15.186,15.186,0,0,0,13.219,30.892V20.23H9.408V15.82h3.81V12.458c0-3.824,2.238-5.936,5.666-5.936a22.707,22.707,0,0,1,3.358.3v3.753H20.35a2.187,2.187,0,0,0-2.444,2.383V15.82h4.16L21.4,20.23H17.906V30.892A15.186,15.186,0,0,0,30.563,15.82Z"
                            transform="translate(-0.563 -0.563)"
                            fill="#4b53f2"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                  <div className="row items">
                    <div className="col-2 col-sm-2 col-md-2">
                      <img src={code} alt="code" />
                    </div>
                    <div className="col-10 col-sm-4 col-md-10">
                      <a href="#github" id="github">
                        GITHUB
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className="col-12 col-sm-6 col-md-5"
                  style={{ padding: "0px" }}
                >
                  <div className="row" style={{ justifyContent: "right" }}>
                    <div
                      className="col-8"
                      style={{
                        display: "flex",
                        direction: "rtl",
                        flexDirection: "column",
                        textAlign: "right",
                        padding: "0px",
                      }}
                    >
                      <div>
                        معاملات روزانه
                        <br />
                        <span style={{ color: "#707070" }}>
                          {data.cc_meta_data == undefined &&
                          data.cc_data == undefined ? (
                            ""
                          ) : (
                            <>
                              $
                              {numberwithCommas(
                                data.cc_data.quote.USD.volume_24h
                              )}
                            </>
                          )}
                        </span>
                      </div>
                      <br />
                      <div>
                        {data.cc_meta_data == undefined &&
                        data.cc_data == undefined ? (
                          ""
                        ) : (
                          <>
                            {numberwithCommas(
                              data.cc_data.quote.USD.price * data.usdt_price
                            )}
                          </>
                        )}
                        <span>تومان</span>
                      </div>
                      <br />
                      <div>
                        <div>محاسبه با نرخ تتر : </div>
                        {data.cc_meta_data == undefined &&
                        data.cc_data == undefined ? (
                          ""
                        ) : (
                          <>
                            <div>{numberwithCommas(data.usdt_price)} تومان</div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="radius caret col-4">
                      <div style={{ marginTop: "8px", color: "white" }}>
                        -1.50
                      </div>
                      <div>
                        <img src={caret} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="d-block d-sm-none col-md-12 col-xl-5"
          style={{ padding: "0px" }}
          dir="ltr"
        >
          <div className="row mainleft">
            <div className="container-left col-12" style={{ padding: "0px" }}>
              <div className="icon">
                {star ? (
                  <div
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="افزودن به مورد علاقه ها"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      id="star"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => setStar(!star)}
                    >
                      <path
                        id="Icon_feather-star"
                        data-name="Icon feather-star"
                        d="M13,3l3.09,6.583L23,10.645l-5,5.121L19.18,23,13,19.583,6.82,23,8,15.766,3,10.645,9.91,9.583Z"
                        transform="translate(-2 -2)"
                        fill="none"
                        stroke="#4e0f8c"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      />
                    </svg>
                  </div>
                ) : (
                  <div
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="افزودن به مورد علاقه ها"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      role="img"
                      width="22"
                      height="22"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 36 36"
                      id="star"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => setStar(!star)}
                    >
                      <g transform="translate(36 0) scale(-1 1)">
                        <path
                          fill="#4e0f8c"
                          d="M34 16.78a2.22 2.22 0 0 0-1.29-4l-9-.34a.23.23 0 0 1-.2-.15l-3.11-8.4a2.22 2.22 0 0 0-4.17 0l-3.1 8.43a.23.23 0 0 1-.2.15l-9 .34a2.22 2.22 0 0 0-1.29 4l7.06 5.55a.23.23 0 0 1 .08.24l-2.43 8.61a2.22 2.22 0 0 0 3.38 2.45l7.46-5a.22.22 0 0 1 .25 0l7.46 5a2.2 2.2 0 0 0 2.55 0a2.2 2.2 0 0 0 .83-2.4l-2.45-8.64a.22.22 0 0 1 .08-.24Z"
                          class="clr-i-solid clr-i-solid-path-1"
                        />
                        <path fill="none" d="M0 0h36v36H0z" />
                      </g>
                    </svg>
                  </div>
                )}
                <div
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="اشتراک گذاری"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.7"
                    height="20"
                    viewBox="0 0 14.7 20"
                    style={{ cursor: "pointer" }}
                  >
                    <path
                      id="Icon_material-share"
                      data-name="Icon material-share"
                      d="M16.75,17.137a2.16,2.16,0,0,0-1.6.773L9.327,13.743a3.4,3.4,0,0,0,0-1.406l5.758-4.127a2.22,2.22,0,0,0,1.666.813A2.771,2.771,0,0,0,19.2,6.012,2.771,2.771,0,0,0,16.75,3,2.771,2.771,0,0,0,14.3,6.012a4,4,0,0,0,.074.7L8.616,10.841a2.22,2.22,0,0,0-1.666-.813A2.771,2.771,0,0,0,4.5,13.04a2.771,2.771,0,0,0,2.45,3.012,2.22,2.22,0,0,0,1.666-.813l5.815,4.177a3.452,3.452,0,0,0-.065.653A2.7,2.7,0,0,0,16.75,23a2.7,2.7,0,0,0,2.385-2.932,2.7,2.7,0,0,0-2.385-2.932Z"
                      transform="translate(-4.5 -3)"
                      fill="#4e0f8c"
                    />
                  </svg>
                </div>
              </div>
              <svg
                id="Line_86"
                xmlns="http://www.w3.org/2000/svg"
                width="1"
                height="408"
                viewBox="0 0 1 408"
              >
                <line
                  data-name="Line 86"
                  y2="408"
                  transform="translate(0.5)"
                  fill="none"
                  stroke="#4e0f8c"
                  strokeWidth="1"
                />
              </svg>
              <div className="col-7" style={{ padding: "0px" }}>
                <div className="row" style={{ justifyContent: "right" }}>
                  <div
                    className="col-8"
                    style={{
                      display: "flex",
                      direction: "rtl",
                      flexDirection: "column",
                      textAlign: "right",
                      padding: "0px",
                    }}
                  >
                    <div>
                      معاملات روزانه
                      <br />
                      <span style={{ color: "#707070" }}>
                        {data.cc_meta_data == undefined &&
                        data.cc_data == undefined ? (
                          ""
                        ) : (
                          <>
                            $
                            {numberwithCommas(
                              data.cc_data.quote.USD.volume_24h
                            )}
                          </>
                        )}
                      </span>
                    </div>
                    <br />
                    <div>
                      {data.cc_meta_data == undefined &&
                      data.cc_data == undefined ? (
                        ""
                      ) : (
                        <>
                          {numberwithCommas(
                            data.cc_data.quote.USD.price * data.usdt_price
                          )}
                        </>
                      )}
                      <span>تومان</span>
                    </div>
                    <br />
                    <div>
                      <div>محاسبه با نرخ تتر : </div>
                      <div>
                        {data.cc_meta_data == undefined &&
                        data.cc_data == undefined ? (
                          ""
                        ) : (
                          <>
                            <div>{numberwithCommas(data.usdt_price)} تومان</div>
                          </>
                        )}{" "}
                        تومان
                      </div>
                    </div>
                  </div>
                  <div className="radius caret col-4">
                    <div style={{ marginTop: "8px", color: "white" }}>
                      -1.50
                    </div>
                    <div>
                      <img src={caret} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-12 col-sm-10 col-md-10"
              style={{ padding: "0px" }}
            >
              <div className="row" style={{ justifyContent: "space-between" }}>
                <div
                  className="col-12 col-sm-6 col-md-6"
                  style={{ padding: "0px" }}
                >
                  <div className="row items">
                    <div className="col-2 col-xl-3">
                      <img src={details.icon} alt="icon" id="icon" />
                    </div>
                    <div className="col-9" style={{ fontWeight: "bold" }}>
                      {" "}
                      {details.nameE}
                    </div>
                  </div>
                  <div className="row items">
                    <div className="col-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                      >
                        <image
                          id="_3629632"
                          data-name="3629632"
                          width="34"
                          height="34"
                          xlinkHref="data:image/png;base64,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"
                        />
                      </svg>
                    </div>
                    <div className="col-10">
                      RANK{" "}
                      <span style={{ color: "#ECA72C" }}>#{details.rank}</span>
                    </div>
                  </div>
                  <div className="row items">
                    <div className="col-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="29.5"
                        height="28"
                        viewBox="0 0 29.5 28"
                      >
                        <g
                          id="Icon_ionic-ios-link"
                          data-name="Icon ionic-ios-link"
                          transform="translate(-3.375 -3.375)"
                        >
                          <path
                            id="Path_258"
                            data-name="Path 258"
                            d="M19.688,23.984l-.084.007a1.163,1.163,0,0,0-.675.316l-4.542,4.542a5.121,5.121,0,0,1-7.242-7.242l4.823-4.823a5.09,5.09,0,0,1,.8-.654,5.168,5.168,0,0,1,1.041-.527,4.923,4.923,0,0,1,1.055-.26,4.986,4.986,0,0,1,.717-.049c.1,0,.2.007.323.014A5.106,5.106,0,0,1,19.2,16.784a5.042,5.042,0,0,1,1.2,1.92,1.107,1.107,0,0,0,1.357.71c.007,0,.014-.007.021-.007s.014,0,.014-.007a1.1,1.1,0,0,0,.738-1.343,6.372,6.372,0,0,0-1.73-2.883,7.4,7.4,0,0,0-4.05-2.06c-.134-.021-.267-.042-.4-.056a7.256,7.256,0,0,0-.78-.042c-.183,0-.366.007-.541.021a7.091,7.091,0,0,0-1.139.176c-.077.014-.148.035-.225.056a7.314,7.314,0,0,0-1.371.513,7.223,7.223,0,0,0-1.948,1.4L5.52,20a7.417,7.417,0,0,0-2.145,5.238,7.393,7.393,0,0,0,12.614,5.224l4.591-4.591A1.113,1.113,0,0,0,19.688,23.984Z"
                            transform="translate(0 -1.25)"
                            fill="#0b0b0c"
                          />
                          <path
                            id="Path_259"
                            data-name="Path 259"
                            d="M30.466,5.534a7.41,7.41,0,0,0-10.455,0l-4.479,4.479a1.13,1.13,0,0,0,.71,1.927,1.142,1.142,0,0,0,.893-.323l4.486-4.472a5.121,5.121,0,0,1,7.242,7.242L24.04,19.209a5.09,5.09,0,0,1-.8.654,5.168,5.168,0,0,1-1.041.527,4.923,4.923,0,0,1-1.055.26,4.986,4.986,0,0,1-.717.049c-.1,0-.2-.007-.323-.014a5.053,5.053,0,0,1-4.444-3.27,1.123,1.123,0,0,0-1.343-.689,1.136,1.136,0,0,0-.795,1.441,6.423,6.423,0,0,0,1.666,2.637h0l.014.014a7.4,7.4,0,0,0,4.451,2.116,7.256,7.256,0,0,0,.78.042q.274,0,.548-.021a8.039,8.039,0,0,0,1.357-.225,7.314,7.314,0,0,0,1.371-.513,7.223,7.223,0,0,0,1.948-1.4L30.48,16a7.4,7.4,0,0,0-.014-10.462Z"
                            transform="translate(0.236)"
                            fill="#0b0b0c"
                          />
                        </g>
                      </svg>
                    </div>
                    <a className="col-10" href={details.url}>
                      {details.url}
                    </a>
                  </div>
                  <div
                    className="row items"
                    style={{ flexDirection: "row", flexWrap: "nowrap" }}
                  >
                    <span className="col-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18.601"
                        height="22.404"
                        viewBox="0 0 18.601 22.404"
                      >
                        <path
                          id="Icon_ionic-ios-search"
                          data-name="Icon ionic-ios-search"
                          d="M4.718,25.275l5.173-6.288a10.1,10.1,0,0,1-1.623-5.57c0-4.929,3.318-8.924,7.416-8.924s7.416,4,7.416,8.93-3.318,8.924-7.416,8.924a6.667,6.667,0,0,1-4.674-1.995L5.871,26.6a.735.735,0,0,1-.576.3.72.72,0,0,1-.547-.262A1.109,1.109,0,0,1,4.718,25.275Zm10.966-4.847A5.339,5.339,0,0,0,19.8,18.375a7.742,7.742,0,0,0,1.705-4.952A7.719,7.719,0,0,0,19.8,8.471a5.339,5.339,0,0,0-4.117-2.053,5.339,5.339,0,0,0-4.117,2.053,7.742,7.742,0,0,0-1.705,4.952,7.719,7.719,0,0,0,1.705,4.952A5.339,5.339,0,0,0,15.685,20.428Z"
                          transform="translate(-4.5 -4.493)"
                          fill="#0b0b0c"
                        />
                      </svg>
                    </span>
                    <span>
                      {details.search.map((value, index) => {
                        return (
                          <>
                            {" "}
                            <a
                              className=""
                              href="#"
                              style={{ padding: "0px" }}
                              key={index}
                            >
                              {value.value}
                            </a>
                            {index + 1 === details.search.length ? (
                              ""
                            ) : (
                              <span style={{ marginLeft: "5px" }}>|</span>
                            )}
                          </>
                        );
                      })}
                    </span>
                  </div>
                  <div className="row items">
                    <div className="col-2 col-md-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16.65"
                        height="22.93"
                        viewBox="0 0 16.65 22.93"
                      >
                        <path
                          id="Icon_material-share"
                          data-name="Icon material-share"
                          d="M18.375,19.207a2.435,2.435,0,0,0-1.813.886l-6.6-4.777a4.644,4.644,0,0,0,.083-.806,4.644,4.644,0,0,0-.083-.806l6.521-4.731a2.5,2.5,0,0,0,1.887.932c1.536,0,2.775-1.542,2.775-3.453S19.911,3,18.375,3,15.6,4.542,15.6,6.453a4.644,4.644,0,0,0,.083.806L9.162,11.99a2.5,2.5,0,0,0-1.887-.932C5.74,11.058,4.5,12.6,4.5,14.511s1.24,3.453,2.775,3.453a2.5,2.5,0,0,0,1.887-.932l6.586,4.789a4,4,0,0,0-.074.748c0,1.853,1.212,3.361,2.7,3.361s2.7-1.508,2.7-3.361-1.212-3.361-2.7-3.361Z"
                          transform="translate(-4.5 -3)"
                          fill="#0b0b0c"
                        />
                      </svg>
                    </div>
                    <div className="col-10 col-sm-4 col-md-10">
                      <a href="#twitter">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          style={{ marginRight: "10px" }}
                          id="Icon_metro-twitter"
                        >
                          <circle
                            id="Ellipse_175"
                            data-name="Ellipse 175"
                            cx="15"
                            cy="15"
                            r="15"
                            fill="#4b53f2"
                          />
                          <path
                            id="Icon_metro-twitter"
                            data-name="Icon metro-twitter"
                            d="M17.571,6.593a5.285,5.285,0,0,1-1.767.6,3.763,3.763,0,0,0,1.353-2.1,5.52,5.52,0,0,1-1.954.919,2.842,2.842,0,0,0-2.246-1.2c-1.7,0-3.077,1.7-3.077,3.787a4.642,4.642,0,0,0,.08.863A8.331,8.331,0,0,1,3.615,5.51a4.452,4.452,0,0,0-.417,1.9,4.075,4.075,0,0,0,1.369,3.152,2.644,2.644,0,0,1-1.394-.474c0,.016,0,.032,0,.048a3.679,3.679,0,0,0,2.469,3.713,2.523,2.523,0,0,1-1.39.065,3.239,3.239,0,0,0,2.875,2.63A5.49,5.49,0,0,1,3.3,18.169a5.088,5.088,0,0,1-.734-.053,7.578,7.578,0,0,0,4.717,1.7c5.66,0,8.756-5.77,8.756-10.774q0-.246-.009-.49a7.236,7.236,0,0,0,1.536-1.96Z"
                            transform="translate(5.005 4.112)"
                            fill="#fff"
                          />
                        </svg>
                      </a>

                      <a href="#facebook">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30.33"
                          viewBox="0 0 30 30.33"
                          id="Icon_awesome-facebook"
                        >
                          <path
                            id="Icon_awesome-facebook"
                            data-name="Icon awesome-facebook"
                            d="M30.563,15.82a15.128,15.128,0,0,0-15-15.257,15.128,15.128,0,0,0-15,15.257A15.186,15.186,0,0,0,13.219,30.892V20.23H9.408V15.82h3.81V12.458c0-3.824,2.238-5.936,5.666-5.936a22.707,22.707,0,0,1,3.358.3v3.753H20.35a2.187,2.187,0,0,0-2.444,2.383V15.82h4.16L21.4,20.23H17.906V30.892A15.186,15.186,0,0,0,30.563,15.82Z"
                            transform="translate(-0.563 -0.563)"
                            fill="#4b53f2"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                  <div className="row items">
                    <div className="col-2 col-sm-2 col-md-2">
                      <img src={code} alt="code" />
                    </div>
                    <div className="col-10 col-sm-4 col-md-10">
                      <a href="#github" id="github">
                        GITHUB
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
